import { component, getter } from '../../decorators';

import l10n from '../../transformers/l10n';

const TIMEOUT = 300;

@component({
   watch: {
      getCartCount(count) {
         this.changed = !!count;
         setTimeout(() => this.changed = false, TIMEOUT);
      }
   }
})
export default class CartMenuItem {
   changed = false

   @getter('getCartCount') getCartCount

   get title() {
      return l10n('cart.breadcrumbs_bin');
   }

   gotoCarts() {
      this.$router.push({ name: 'Carts' });
   }

   toCart(cart) {
      this.$router.push({ name: 'CartInfo', params: { cid: cart.id } });
      this.deactivate();
   }
}
